<template>
  <div
    :class="[
      'anz-flex anz-flex-wrap anz-px-s anz-px-m-sm',
      cssClass,
      {
        'anz-bg-gray-50 anz-b-rounded anz-pt-xs anz-pt-s-sm anz-pb-xs-sm': background,
        'anz-bb-sm anz-pb-xs': !background,
      },
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AUserProfileMetaRow',
  props: {
    background: {
      Type: Boolean,
      Default: false,
    },
    cssClass: {
      Type: String,
      Default: '',
    },
  },
}
</script>
